const ConstantAction = {
    ACTION_GET_REPORT_USER: 1,
    ACTION_GET_REPORT_TEACHER_BY_STUDENT: 2,
    ACTION_GET_ADVANCE_BOOK_STUDENT: 3,
    ACTION_GET_ADVANCE_BOOK_TEACHER: 4,
    ACTION_GET_SCHOOL_USERS: 5,
    ACTION_GET_ADVANCE_AVERAGE_TEACHER_BOOK: 6
}
export default ConstantAction;